import CryptoJS from "crypto-js";

export type MD5Fromat = "hex" | "base64";
/**
 * Computes the MD5 hash of a file
 * @param file - The file to hash
 * @param format - Output format: 'hex' (default) or 'base64'
 * @returns Promise that resolves to the hash string in the specified format
 */
export async function computeFileMD5(
  file: File,
  format: MD5Fromat = "hex",
): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const arrayBuffer = e.target?.result as ArrayBuffer;
        const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer);
        const hash = CryptoJS.MD5(wordArray);

        const result =
          format === "base64"
            ? hash.toString(CryptoJS.enc.Base64)
            : hash.toString(); // Default to hex

        resolve(result);
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsArrayBuffer(file);
  });
}
